export const APPLY_GLOBAL_PERIOD = "applyGlobalPeriod";
export const SELECTED_GLOBAL_PERIOD = "selectedGlobalPeriod";
export const SIDEBAR_OPTIONS = "sidebarOptions";
export const OBJECTIVES_ONLINE_DISPONIBILIDAD =
  "listaObjetivosOnlineDisponibilidad";
export const SIDEBAR_FILTERS_TAGS = "sidebarFiltersTags";
export const FILTER_TAGS_TYPE = "filterTagsType";
